(() => {
  const root = window.Shopify?.routes?.root || '/';
  function init(scope = document) {
    const elements = scope.querySelectorAll('[data-reveal]');
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
      document.documentElement.classList.add('motion-ready');
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: 0.08 });
      elements.forEach(element => observer.observe(element));
    } else elements.forEach(element => element.classList.add('is-visible'));
    scope.querySelectorAll('[data-gallery]').forEach(gallery => {
      const buttons = gallery.querySelectorAll('[data-gallery-src]');
      buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === 0)));
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  const updateHeader = () => document.documentElement.classList.toggle('is-scrolled', window.scrollY > 24);
  updateHeader(); window.addEventListener('scroll', updateHeader, {passive: true});
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gallery-src]');
    if (!button) return;
    const gallery = button.closest('[data-gallery]');
    const image = gallery.querySelector('.product-gallery-stage img');
    image.removeAttribute('srcset'); image.src = button.dataset.gallerySrc; image.alt = button.dataset.galleryAlt || '';
    gallery.querySelectorAll('[data-gallery-src]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-variant-select]')) return;
    const form = event.target.form, option = event.target.selectedOptions[0];
    const available = option.dataset.available === 'true';
    form.querySelector('[data-variant-price]').textContent = option.dataset.price;
    const quantity = form.querySelector('[name="quantity"]');
    quantity.min = option.dataset.min || '1';
    quantity.step = option.dataset.step || '1';
    if (option.dataset.max) quantity.max = option.dataset.max;
    else quantity.removeAttribute('max');
    if (!quantity.validity.valid) quantity.value = quantity.min;
    const button = form.querySelector('[data-add-button]');
    button.disabled = !available; button.textContent = available ? 'Add to cart' : 'Sold out';
    const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-product-form]')) return;
    // Native form submission remains the no-JS fallback.
    event.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const button = form.querySelector('button[type=submit]'), status = form.querySelector('[role=status]');
    if (button.disabled) return;
    form.dataset.busy = 'true'; button.disabled = true; button.setAttribute('aria-busy','true'); status.textContent = 'Adding…';
    let added = false;
    try {
      const response = await fetch(root + 'cart/add.js', {method: 'POST',body: new FormData(form),headers: {'Accept':'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
      added = true;
      status.replaceChildren(document.createTextNode('Added. '));
      const link = document.createElement('a'); link.href = root + 'cart'; link.textContent = 'View cart'; status.append(link);
      const cartResponse = await fetch(root + 'cart.js', {headers: {'Accept':'application/json'}});
      if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-link]').forEach(link => { link.textContent = `Cart (${cart.item_count})`; }); }
    } catch (error) {
      if (!added) status.textContent = error.message || 'Could not add this item. Check your connection and try again.';
    } finally {
      delete form.dataset.busy; button.removeAttribute('aria-busy');
      const select = form.querySelector('[data-variant-select]'); button.disabled = select ? select.selectedOptions[0].dataset.available !== 'true' : false;
    }
  });
})();
